import { userActions } from "../../actionTypes";

const initialState = {
	status: false,
	loading: false,
	error: null,
};

const Reducer = (state = initialState, action) => {
	switch (action.type) {
		case userActions.RESET_PASSWORD: {
			return { ...state, loading: true };
		}

		case userActions.RESET_FULLFILLED: {
			return { ...state, loading: false, status: true };
		}

		case userActions.RESET_REJECTED: {
			return { ...state, loading: false, error: action.payload };
		}

		default:
	}

	return state;
};

export default Reducer;
